<div id="app-workflows-createsd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main"
    [attr.aria-label]="('WORKFLOWCREATE' | translate)">
    <app-headline [type]="'h4'" [class]="'text-muted fw-bold m-0 pe-2'"
        [title]="('WORKFLOWCREATORTITLE' | translate)"></app-headline>
    <div class="card mb-3 d-flex flex-column overflow-hidden">
        <div class="card-body d-flex flex-column ps-3 py-3 pe-1 h-100">
            <!-- Toolbar -->
            <div class="d-flex justify-content-between align-items-center">
                <app-headline [type]="'h6'" [title]="('UNSAVED' | translate)"
                    [class]="'text-danger fw-bold'"></app-headline>
                <div class="d-flex align-items-center gap-1">
                    <app-tooltip [tooltipTarget]="'.saveform-icon'" [text]="('WORKFLOWSAVEFORMTOOLTIP' | translate)"
                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                        <app-form-button (click)="true"
                            [cssClass]="'saveform-icon e-btn e-flat fs-normal text-primary p-1'" [icon]="'save'"
                            [iconClass]="'fs-4 mts-icon-filled  m-1'"></app-form-button>
                    </app-tooltip>
                    <app-tooltip [tooltipTarget]="'.globalsettings-icon'"
                        [text]="('WORKFLOWGLOBALSETTINGSTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                        [height]="'auto'">
                        <app-form-button (click)="editSettings()"
                            [cssClass]="'globalsettings-icon e-btn e-flat fs-normal text-muted p-1'" [icon]="'settings'"
                            [iconClass]="'fs-4 mts-icon-filled m-1'"></app-form-button>
                    </app-tooltip>
                    <app-form-button [text]="'WORKFLOWBACKTOWORKFLOWS' | translate" (click)="true"
                        [cssClass]="'e-outline e-small fw-semibold align-middle d-none d-md-flex'"></app-form-button>
                    <app-form-button [text]="'WORKFLOWPUBLISHBUTTON' | translate" (click)="true"
                        [cssClass]="'e-btn e-primary e-small fw-semibold d-none d-md-flex'"></app-form-button>
                </div>
            </div>
            <div class="d-md-none d-flex align-items-center justify-content-end flex-wrap px-3 pt-1 gap-2">
                <app-form-button [text]="'WORKFLOWBACKTOWORKFLOWS' | translate" (click)="true"
                    [cssClass]="'e-outline e-small fw-semibold align-middle'"></app-form-button>
                <app-form-button [text]="'WORKFLOWPUBLISHBUTTON' | translate" (click)="true"
                    [cssClass]="'e-btn e-primary e-small fw-semibold'"></app-form-button>
            </div>

            <!-- Scrollable content-->
            <div class="custom-scrollbar overflow-y-auto mt-2 pe-2">
                <!--WORKFLOW DETAILS CARD -->
                <div class="card workflowCard">
                    <div class="card-body">
                        <div class="d-flex justify-content-end">
                            <!-- Workflow Type Badge-->
                            <app-pill [fontSize]="'fs-default'" [fontColor]="'text-muted'" [bgColor]="'bg-transparent'"
                                [border]="true" [brdColor]="'brd-muted'" [rounded]="false">Description</app-pill>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center flex-wrap gap-2 mb-3 pt-2">
                                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                    [title]="'Workflow title'"></app-headline>
                            </div>
                            <div class="d-flex my-2">
                                <app-content [type]="'richtext'"
                                    [innerHTML]="'It is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'"></app-content>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <app-form-button [text]="'SHOWATTACHMENTS' | translate" (click)="true"
                                [cssClass]="'e-btn e-flat fw-bold fs-small text-muted p-1'" [icon]="'attach_file'"
                                [iconPosition]="'left'" [iconClass]="'fs-5'"
                                [hideTextOnMobile]="true"></app-form-button>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex align-items-center gap-4 flex-wrap">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Published
                                        at:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                        [fontDecoration]="'fw-bold'">Immediately</app-content>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Expires
                                        at:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                        [fontDecoration]="'fw-bold'">18.05.2025</app-content>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Unpublished
                                        at:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                        [fontDecoration]="'fw-bold'">18.06.2025</app-content>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'"
                                        [fontColor]="'text-muted'">Type:</app-content>
                                </div>
                                <div class="d-flex align-items-start">
                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-danger'"
                                        [fontDecoration]="'fw-bold'">Confidential</app-content>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Add requester button -->
                <div class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 30px;" class="bg-aqua"></div>
                    <app-form-button [style]="'btn'" [text]="'WORKFLOWADDREQUESTERBUTTON' | translate" (click)="true"
                        [icon]="'add_circle'" [iconPosition]="'left'" [cssClass]="'rounded-pill bg-aqua text-white p-2'"
                        [iconClass]="'fs-4 text-white'"></app-form-button>
                    <!-- Only add the bottom line if there is another stage fallowing-->
                    <div *ngIf="true" style="width: 2px; height: 30px;" class="bg-aqua"></div>
                </div>

                <!-- REQUESTER STAGE-->
                <div class="card workflowCard" [class.reviewer_stage]="false">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1">
                                <app-headline [title]="'RQ.'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>

                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-tooltip [tooltipTarget]="'.stage-options'"
                                    [text]="('WORKFLOWSTAGESETTINGSTOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button [cssClass]="'stage-options e-btn e-flat fs-normal text-muted p-1'"
                                        [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONS' | translate)"></app-form-button>
                                </app-tooltip>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                    [bgColor]="'bg-transparent'" [border]="true" [brdColor]="'brd-primary'"
                                    [rounded]="false">Requester</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Arrows Up and Down -->
                            <div
                                class="flex-column align-items-center pe-2 gap-3 justify-content-center d-none d-md-flex">

                            </div>
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If all users was selected in the Stage Settings or if one email was selected -->
                                    <app-pill [bgColor]="'bg-grey'">{{ 'WORKFLOWREQUESTAVAILABLEFORALLUSERS' | translate
                                        }}</app-pill>
                                    <!-- If there is specific group/users who were selected in the stage settings -->
                                    <app-form-button (click)="onOpenDialog($event, 'show-workflowstageparticipants')"
                                        [cssClass]="'e-btn e-outline p-0 e-verysmall e-simple'"
                                        [text]="('WORKFLOWSTAGESHOWREQUESTERS' | translate)"></app-form-button>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <div class="d-flex justify-content-center flex-wrap gap-2 my-3">
                                    <app-form-button [text]="'WORKFLOWSTAGECREATECUSTOMFORM' | translate"
                                        (click)="openFeedbackCreator()" [icon]="'forms_add_on'" [iconPosition]="'right'"
                                        [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
                                    <app-form-button [text]="'WORKFLOWSTAGEEDITCUSTOMFORM' | translate"
                                        (click)="openFeedbackCreator()" [icon]="'edit_note'" [iconPosition]="'right'"
                                        [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
                                    <app-form-button [text]="'WORKFLOWSTAGEDELETECUSTOMFORM' | translate" (click)="true"
                                        [icon]="'delete'" [iconPosition]="'right'" [cssClass]="'e-danger fw-semibold'"
                                        [iconClass]="'fs-5'"></app-form-button>
                                </div>

                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 col-12 col-md-6">
                                            <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'dropdown_choice'"
                                                [dataSource]="dropdown_datasource" [placeholder]="'SELECT' | translate"
                                                [marker]="'priority'"></app-form-dropdown>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-form-textarea [placeholder]="('WORKFLOWTEXTPLACEHOLDER' | translate)"
                                                [fCN]="'workflow_text'" [fG]="workflowCreateForm" [maxChars]="250"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date-time [fG]="workflowCreateForm" [fCN]="'datetime_answer'"
                                                    [disabled]="false"></app-form-date-time>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date [fG]="workflowCreateForm" [fCN]="'date_asnwer'"
                                                    [disabled]="false"></app-form-date>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <ejs-timepicker [placeholder]="'SELECTTIME' | translate"
                                                    [enabled]="true" [value]='dateValue' [format]='formatString'
                                                    [step]='interval' [min]='minValue'
                                                    [max]='maxValue'></ejs-timepicker>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-dialog-documents-upload [view]="'component'"
                                                    [(files)]="attachmentFiles" [multiple]="true"
                                                    [type]="'both'"></app-dialog-documents-upload>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="d-flex align-items-center gap-1">
                                <app-tooltip [tooltipTarget]="'.deletequestion-icon'" [text]="'Delete this Stage'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="true" [cssClass]="'deletequestion-icon e-btn e-flat p-0'"
                                        [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                                </app-tooltip>
                            </div>
                            <!--<div class="d-flex align-items-center">
                                <div class="btn-group dropup">
                                    <div class="d-flex align-items-center gap-2 cursor-pointer" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" [attr.aria-label]="('WOKFLOWSTAGEOPTIONPOPUP' | translate)">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">Stage options</app-content>
                                        <app-icon-badge [style]="'default'" [icon]="'tune'" [fontSize]="'fs-4'"></app-icon-badge>
                                    </div>
                                    <div class="dropdown-menu">
                                        <div class="px-3 py-3">
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'add_comment'" [fG]="workflowCreateForm" [cssClass]="''" [labelPosition]="'After'" [cssClass]="'lh-base'" [label]="'WOKFLOWADDCOMMENTLABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'visible_for_next_stage'" [fG]="workflowCreateForm" [cssClass]="''" [labelPosition]="'After'" [cssClass]="'lh-base'" [label]="'WOKFLOWVISIBLEFORNEXTSTAGELABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3 d-flex align-items-center gap-1">
                                                <div class="col-6">
                                                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Deadline (days)</app-content>
                                                </div>
                                                <div class="col-6">
                                                    <app-form-numeric [fG]="workflowCreateForm" [fCN]="'deadline_in_days'"></app-form-numeric>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>-->

                        </div>
                    </div>
                </div>
                <!-- Add stage button -->
                <div class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 30px;" class="bg-aqua"></div>
                    <app-form-button [style]="'btn'" [text]="'WORKFLOWADDSTAGEBUTTON' | translate"
                        (click)="onOpenDialog($event,'show-workflowtype')" [icon]="'add_circle'" [iconPosition]="'left'"
                        [cssClass]="'rounded-pill bg-aqua text-white p-2'"
                        [iconClass]="'fs-4 text-white'"></app-form-button>
                    <!-- Only add the bottom line if there is another stage fallowing-->
                    <div *ngIf="true" style="width: 2px; height: 30px;" class="bg-aqua"></div>
                </div>
                <!-- REVIEWER STAGE-->
                <div class="card workflowCard" [class.reviewer_stage]="isReviewerStage">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1">
                                <app-headline [title]="'ST2.'" [type]="'h6'"
                                    [class]="'fw-bold text-orange'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-tooltip [tooltipTarget]="'.stage-options'"
                                    [text]="('WORKFLOWSTAGESETTINGSTOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button [cssClass]="'stage-options e-btn e-flat fs-normal text-muted p-1'"
                                        [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONS' | translate)"></app-form-button>
                                </app-tooltip>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontColor]="'text-orange'" [fontSize]="'fs-default'" [border]="true"
                                    [bgColor]="'bg-faintorange'" [brdColor]="'brd-orange'"
                                    [rounded]="false">Review</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Arrows Up and Down -->
                            <div
                                class="flex-column align-items-center pe-2 gap-3 justify-content-center d-none d-md-flex">
                                <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Question Up'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-icon-badge [style]="'default'" [icon]="'arrow_upward'" [fontSize]="'fs-3'"
                                        [class]="'moveup-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                                </app-tooltip>
                                <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Question Down'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-icon-badge [style]="'default'" [icon]="'arrow_downward'" [fontSize]="'fs-3'"
                                        [class]="'movedown-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                                </app-tooltip>
                            </div>
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <!-- Title -->
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <!--Switch between simple and form -->
                                <div class="d-flex align-items-center gap-2 my-3">
                                    <!-- 'WORKFLOWUSESIMPLEACCEPTREJECTLOGIC' | translate-->
                                    <app-headline [title]="'WORKFLOWQUICKREVIEWLABEL' | translate" [type]="'h6'"
                                        [class]="'text-primary fw-bold'"></app-headline>
                                    <app-form-switch [fG]="workflowCreateForm"
                                        [fCN]="'is_simple_accept'"></app-form-switch>
                                </div>
                                <!--Simple review condition -->
                                <div *ngIf="workflowCreateForm.get('is_simple_accept')?.value"
                                    class="d-flex flex-column gap-2">
                                    <!--The reviewer will see two buttons — Accept and Reject. Each choice will trigger the specific action or next stage you assign to it.-->
                                    <app-content [fontSize]="'fs-default'"
                                        [fontColor]="'text-muted'">{{'WORKFLOWSIMPLEACCEPTREJECTTEXT' | translate
                                        }}</app-content>
                                    <div class="d-flex align-items-center gap-2">
                                        <app-headline [title]="'IF' | translate" [type]="'h6'"
                                            [class]="'text-primary fw-bold'"></app-headline>
                                        <button class="e-btn e-success e-small p-1"><span
                                                class="fs-default fw-bold">ACCEPTED</span></button>
                                        <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'accept_option'"
                                            [dataSource]="accept_datasource" [placeholder]="'SELECTOPTION' | translate"
                                            [popupWidth]="'auto'" [cssClass]="'small-filter-dropdown'">
                                        </app-form-dropdown>
                                    </div>
                                    <div class="d-flex align-items-center gap-2">
                                        <app-headline [title]="'IF' | translate" [type]="'h6'"
                                            [class]="'text-primary fw-bold'"></app-headline>
                                        <button class="e-btn e-danger e-small p-1"><span
                                                class="fs-default fw-bold">REJECTED</span></button>
                                        <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'accept_option'"
                                            [dataSource]="rejection_clause_datasource"
                                            [placeholder]="'SELECTOPTION' | translate" [popupWidth]="'auto'"
                                            [cssClass]="'small-filter-dropdown'">
                                        </app-form-dropdown>
                                        <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'accept_option'"
                                            [dataSource]="rejected_target" [placeholder]="'SELECTOPTION' | translate"
                                            [popupWidth]="'auto'" [cssClass]="'small-filter-dropdown'">
                                        </app-form-dropdown>
                                    </div>
                                </div>
                                <!--Custom Form section-->
                                <div *ngIf="!workflowCreateForm.get('is_simple_accept')?.value"
                                    class="d-flex flex-column">
                                    <!--Create a custom form with inputs like dropdowns or sliders. Use skip logic to direct the workflow to a specific stage based on the reviewer’s response.-->
                                    <app-content [fontSize]="'fs-default'"
                                        [fontColor]="'text-muted'">{{'WORKFLOWCUSTOMFORMLOGICTEXT' | translate
                                        }}</app-content>
                                    <div class="d-flex justify-content-center flex-wrap gap-2 my-3">
                                        <app-form-button [text]="'WORKFLOWSTAGECREATECUSTOMFORM' | translate"
                                            (click)="openFeedbackCreator()" [icon]="'forms_add_on'"
                                            [iconPosition]="'right'" [cssClass]="'e-primary fw-semibold'"
                                            [iconClass]="'fs-5'"></app-form-button>
                                        <app-form-button [text]="'WORKFLOWSTAGEEDITCUSTOMFORM' | translate"
                                            (click)="openFeedbackCreator()" [icon]="'edit_note'"
                                            [iconPosition]="'right'" [cssClass]="'e-primary fw-semibold'"
                                            [iconClass]="'fs-5'"></app-form-button>
                                        <app-form-button [text]="'WORKFLOWSTAGEDELETECUSTOMFORM' | translate"
                                            (click)="true" [icon]="'delete'" [iconPosition]="'right'"
                                            [cssClass]="'e-danger fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
                                    </div>

                                    <!-- Composed Form Container -->
                                    <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                        <!-- Radio Type-->
                                        <div class="d-flex flex-column">
                                            <div class="d-flex flex-column">
                                                <div class="mt-2">
                                                    <app-form-label
                                                        [label]="'This is a dynamic answer label'"></app-form-label>
                                                </div>
                                                <div class="mt-2 mb-1">
                                                    <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                        [value]="'optional'"
                                                        [placeholder]="'This is the radio dynamic label'"
                                                        [cssClass]="'e-large'"></app-form-radio>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="mt-2">
                                                    <app-form-label
                                                        [label]="'This is a dynamic answer label'"></app-form-label>
                                                </div>
                                                <div class="mt-2 mb-1">
                                                    <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                        [value]="'optional'"
                                                        [placeholder]="'This is the radio dynamic label'"
                                                        [cssClass]="'e-large'"></app-form-radio>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <div class="mt-2 mb-1">
                                                    <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                        [value]="'optional'"
                                                        [placeholder]="'This is the radio dynamic label'"
                                                        [cssClass]="'e-large'"></app-form-radio>
                                                </div>
                                            </div>
                                            <!-- If requires mandatory comment -->
                                            <div class="d-flex flex-column my-3 w-100">
                                                <app-form-label
                                                    [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                                <app-form-textarea
                                                    [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                    [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                    [fCN]="'workflow_comment'" [fG]="workflowCreateForm"
                                                    [maxChars]="200" [rows]="4"></app-form-textarea>
                                            </div>
                                        </div>

                                        <!-- Slider -->
                                        <div class="d-flex flex-column w-100">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 ps-2 pe-3">
                                                <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                    [ticks]="ticks" [step]="0.5"
                                                    [tooltip]="{ placement: 'Before', isVisible: true}"></ejs-slider>
                                            </div>
                                            <!-- If requires mandatory comment -->
                                            <div class="d-flex flex-column my-3 w-100">
                                                <app-form-label
                                                    [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                                <app-form-textarea
                                                    [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                    [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                    [fCN]="'workflow_comment'" [fG]="workflowCreateForm"
                                                    [maxChars]="200" [rows]="4"></app-form-textarea>
                                            </div>
                                        </div>

                                        <!-- Rating -->
                                        <div class="d-flex flex-column w-100">
                                            <div class="d-flex flex-column align-items-center">
                                                <div class="mt-2">
                                                    <app-form-label
                                                        [label]="'This is a dynamic answer label'"></app-form-label>
                                                </div>
                                                <div class="mt-2 mb-1">
                                                    <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                        precision="Half" allowReset="true" />
                                                </div>
                                            </div>
                                            <!-- If requires mandatory comment -->
                                            <div class="d-flex flex-column my-3 w-100">
                                                <app-form-label
                                                    [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                                <app-form-textarea
                                                    [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                    [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                    [fCN]="'workflow_comment'" [fG]="workflowCreateForm"
                                                    [maxChars]="200" [rows]="4"></app-form-textarea>
                                            </div>
                                        </div>

                                        <!-- Dropdown -->
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'dropdown_choice'"
                                                    [dataSource]="dropdown_datasource"
                                                    [placeholder]="'SELECT' | translate"
                                                    [marker]="'priority'"></app-form-dropdown>
                                            </div>
                                            <!-- If requires mandatory comment -->
                                            <div class="d-flex flex-column my-3 w-100">
                                                <app-form-label
                                                    [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                                <app-form-textarea
                                                    [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                    [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                    [fCN]="'workflow_comment'" [fG]="workflowCreateForm"
                                                    [maxChars]="200" [rows]="4"></app-form-textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="d-flex align-items-center gap-1">
                                <div class="d-flex d-md-none align-items-center gap-1">
                                    <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Stage Up'"
                                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="true"
                                            [cssClass]="'moveup-arrow e-btn e-flat p-0 text-skyblue'"
                                            [icon]="'arrow_upward'" [iconClass]="'fs-3 m-0'"></app-form-button>
                                    </app-tooltip>
                                    <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Stage Down'"
                                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="true"
                                            [cssClass]="'movedown-arrow e-btn e-flat p-0 text-skyblue'"
                                            [icon]="'arrow_downward'" [iconClass]="'fs-3 m-0'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-tooltip [tooltipTarget]="'.deletequestion-icon'"
                                    [text]="'WORKFLOWDELETECURRECTSTAGETOOLTIP' | translate" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="true" [cssClass]="'deletequestion-icon e-btn e-flat p-0'"
                                        [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                                </app-tooltip>
                            </div>
                            <div class="d-flex align-items-center">
                                <div class="btn-group dropup">
                                    <div class="d-flex align-items-center gap-2 cursor-pointer"
                                        data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONPOPUP' | translate)">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [fontDecoration]="'fw-bold'">Stage options</app-content>
                                        <app-icon-badge [style]="'default'" [icon]="'tune'"
                                            [fontSize]="'fs-4'"></app-icon-badge>
                                    </div>
                                    <div class="dropdown-menu">
                                        <div class="px-3 py-3">
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'add_comment'" [fG]="workflowCreateForm"
                                                    [cssClass]="''" [labelPosition]="'After'" [cssClass]="'lh-base'"
                                                    [label]="'WORKFLOWADDCOMMENTLABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'visible_for_next_stage'"
                                                    [fG]="workflowCreateForm" [cssClass]="''" [labelPosition]="'After'"
                                                    [cssClass]="'lh-base'"
                                                    [label]="'WORKFLOWVISIBLEFORNEXTSTAGELABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3 d-flex align-items-center gap-1">
                                                <div class="col-6">
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Deadline (days)</app-content>
                                                </div>
                                                <div class="col-6">
                                                    <app-form-numeric [fG]="workflowCreateForm"
                                                        [fCN]="'deadline_in_days'"></app-form-numeric>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Add stage button -->
                <div class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 30px;" class="bg-aqua"></div>
                    <app-form-button [style]="'btn'" [text]="'WORKFLOWADDSTAGEBUTTON' | translate"
                        (click)="onOpenDialog($event,'show-workflowtype')" [icon]="'add_circle'" [iconPosition]="'left'"
                        [cssClass]="'rounded-pill bg-aqua text-white p-2'"
                        [iconClass]="'fs-4 text-white'"></app-form-button>
                    <!-- Only add the bottom line if there is another stage fallowing-->
                    <div *ngIf="true" style="width: 2px; height: 30px;" class="bg-aqua"></div>
                </div>
                <!-- TASK/TEAM TASK STAGE-->
                <div class="card workflowCard" [class.reviewer_stage]="false">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1">
                                <app-headline [title]="'ST3.'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <div *ngIf="isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-collapse'"
                                        [text]="('WORKFLOWSTAGECOLLAPSETOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_up'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <div *ngIf="!isStageExpanded">
                                    <app-tooltip [tooltipTarget]="'.question-expande'"
                                        [text]="('WORKFLOWSTAGEEXPANDTOOLTIP' | translate)" [type]="'Default'"
                                        [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="toggleExpanded()"
                                            [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                                            [icon]="'expand_circle_down'"
                                            [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-tooltip [tooltipTarget]="'.stage-options'"
                                    [text]="('WORKFLOWSTAGESETTINGSTOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button [cssClass]="'stage-options e-btn e-flat fs-normal text-muted p-1'"
                                        [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONS' | translate)"></app-form-button>
                                </app-tooltip>
                                <!-- Workflow Type Badge-->
                                <!-- If there is specific group/users who were selected to work as a team then use Team Task otherwise Task-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-success'"
                                    [bgColor]="'bg-faintgreen'" [border]="true" [brdColor]="'brd-success'"
                                    [rounded]="false">Task / Team Task</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Arrows Up and Down -->
                            <div
                                class="flex-column align-items-center pe-2 gap-3 justify-content-center d-none d-md-flex">
                                <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Question Up'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-icon-badge [style]="'default'" [icon]="'arrow_upward'" [fontSize]="'fs-3'"
                                        [class]="'moveup-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                                </app-tooltip>
                                <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Question Down'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-icon-badge [style]="'default'" [icon]="'arrow_downward'" [fontSize]="'fs-3'"
                                        [class]="'movedown-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                                </app-tooltip>
                            </div>
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1">
                                    <!-- If one users was selected in the Stage Settings -->
                                    <app-pill [bgColor]="'bg-grey'">Carsten Jobmann</app-pill>
                                    <!-- If there is specific group/users who were selected to work as a team -->
                                    <app-form-button (click)="onOpenDialog($event, 'show-workflowstageparticipants')"
                                        [cssClass]="'e-btn e-outline p-0 e-verysmall e-simple'"
                                        [text]="('WORKFLOWSTAGESHOWTEAMPARTICIPANTS' | translate)"></app-form-button>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                                <div class="d-flex justify-content-center flex-wrap gap-2 my-3">
                                    <app-form-button [text]="'WORKFLOWSTAGECREATECUSTOMFORM' | translate"
                                        (click)="openFeedbackCreator()" [icon]="'forms_add_on'" [iconPosition]="'right'"
                                        [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
                                    <app-form-button [text]="'WORKFLOWSTAGEEDITCUSTOMFORM' | translate"
                                        (click)="openFeedbackCreator()" [icon]="'edit_note'" [iconPosition]="'right'"
                                        [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
                                    <app-form-button [text]="'WORKFLOWSTAGEDELETECUSTOMFORM' | translate" (click)="true"
                                        [icon]="'delete'" [iconPosition]="'right'" [cssClass]="'e-danger fw-semibold'"
                                        [iconClass]="'fs-5'"></app-form-button>
                                </div>

                                <!-- Composed Form Container -->
                                <div [class.d-none]="!isStageExpanded" class="d-flex flex-column my-3">
                                    <!-- Radio Type-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-radio [fG]="workflowCreateForm" [fCN]="'radio_options'"
                                                    [value]="'optional'"
                                                    [placeholder]="'This is the radio dynamic label'"
                                                    [cssClass]="'e-large'"></app-form-radio>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Image selection -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-wrap justify-content-center gap-4 my-3">
                                            <!-- Tile 1 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 2 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Tile 3 -->
                                            <div class="image-radio-tile d-flex flex-column align-items-center">
                                                <div
                                                    class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                                                    <img src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                                                        alt="Sample Image" appNgSrcImageError>
                                                </div>

                                                <div class="d-flex flex-column align-items-center">
                                                    <div
                                                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                                                        <app-form-radio [fG]="workflowCreateForm"
                                                            [fCN]="'radio_image_options'" [value]="'optional'"
                                                            [cssClass]="'e-large  mb-3'"></app-form-radio>
                                                    </div>

                                                    <div class="d-flex mt-2 p-1">
                                                        <app-form-label
                                                            [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Slider -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 ps-2 pe-3">
                                            <ejs-slider [type]="'MinRange'" [value]="1" [min]="0" [max]="10"
                                                [ticks]="ticks" [step]="0.5"
                                                [tooltip]="{ placement: 'Before', isVisible: true}"></ejs-slider>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Rating -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="d-flex flex-column align-items-center">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <input ejs-rating value="0" showLabel="true" labelPosition="Top"
                                                    precision="Half" allowReset="true" />
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- Dropdown -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1 col-12 col-md-6">
                                            <app-form-dropdown [fG]="workflowCreateForm" [fCN]="'dropdown_choice'"
                                                [dataSource]="dropdown_datasource" [placeholder]="'SELECT' | translate"
                                                [marker]="'priority'"></app-form-dropdown>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--CHECKBOX-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-form-checkbox [fCN]="'checkbox_option'" [fG]="workflowCreateForm"
                                                    [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                                                    [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TEXT -->
                                    <div class="d-flex flex-column w-100 ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="mt-2 mb-1">
                                            <app-form-textarea [placeholder]="('WORKFLOWTEXTPLACEHOLDER' | translate)"
                                                [fCN]="'workflow_text'" [fG]="workflowCreateForm" [maxChars]="250"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!--REORDERABLE LIST-->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="mt-2">
                                            <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                                        </div>
                                        <div class="d-flex flex-column mt-2 mb-1">
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">1.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">2.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="d-flex align-items-stretch">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-end p-2">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-primary'"
                                                            [fontDecoration]="'fw-bold'">3.</app-content>
                                                    </div>
                                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                                        <app-content [fontSize]="'fs-default'"
                                                            [fontColor]="'text-muted'">This is a option in reordarable
                                                            list</app-content>
                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center justify-content-center border-start p-2">
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                        <app-form-button [style]="'btn'"
                                                            [cssClass]="'btn-link p-0 text-muted'"
                                                            [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'"
                                                            (click)="true"></app-form-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('WORKFLOWMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('WORKFLOWMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date-time [fG]="workflowCreateForm" [fCN]="'datetime_answer'"
                                                    [disabled]="false"></app-form-date-time>
                                            </div>
                                        </div>

                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- DATE -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <app-form-date [fG]="workflowCreateForm" [fCN]="'date_asnwer'"
                                                    [disabled]="false"></app-form-date>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- TIME -->
                                    <div class="d-flex flex-column ps-md-3">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2">
                                                <app-form-label
                                                    [label]="'This is a dynamic answer label'"></app-form-label>
                                            </div>
                                            <div class="mt-2 mb-1 col-12 col-md-6">
                                                <ejs-timepicker [placeholder]="'SELECTTIME' | translate"
                                                    [enabled]="true" [value]='dateValue' [format]='formatString'
                                                    [step]='interval' [min]='minValue'
                                                    [max]='maxValue'></ejs-timepicker>
                                            </div>
                                        </div>
                                        <!-- If requires mandatory comment -->
                                        <div class="d-flex flex-column my-3 w-100 ">
                                            <app-form-label
                                                [label]="'WORKFLOWMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                                            <app-form-textarea
                                                [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                                                [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)"
                                                [fCN]="'workflow_comment'" [fG]="workflowCreateForm" [maxChars]="200"
                                                [rows]="4"></app-form-textarea>
                                        </div>
                                    </div>

                                    <!-- FILE UPLOAD-->
                                    <div class="d-flex flex-column ps-md-3 w-100">
                                        <div class="d-flex flex-column">
                                            <div class="mt-2 mb-1">
                                                <app-dialog-documents-upload [view]="'component'"
                                                    [(files)]="attachmentFiles" [multiple]="true"
                                                    [type]="'both'"></app-dialog-documents-upload>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="d-flex align-items-center gap-1">
                                <div class="d-flex d-md-none align-items-center gap-1">
                                    <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Stage Up'"
                                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="true"
                                            [cssClass]="'moveup-arrow e-btn e-flat p-0 text-skyblue'"
                                            [icon]="'arrow_upward'" [iconClass]="'fs-3 m-0'"></app-form-button>
                                    </app-tooltip>
                                    <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Stage Down'"
                                        [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                        <app-form-button (click)="true"
                                            [cssClass]="'movedown-arrow e-btn e-flat p-0 text-skyblue'"
                                            [icon]="'arrow_downward'" [iconClass]="'fs-3 m-0'"></app-form-button>
                                    </app-tooltip>
                                </div>
                                <app-tooltip [tooltipTarget]="'.deletequestion-icon'" [text]="'Delete this Stage'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="true" [cssClass]="'deletequestion-icon e-btn e-flat p-0'"
                                        [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                                </app-tooltip>
                            </div>
                            <div class="d-flex align-items-center">

                                <div class="btn-group dropup">
                                    <div class="d-flex align-items-center gap-2 cursor-pointer"
                                        data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONPOPUP' | translate)">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [fontDecoration]="'fw-bold'">Stage options</app-content>
                                        <app-icon-badge [style]="'default'" [icon]="'tune'"
                                            [fontSize]="'fs-4'"></app-icon-badge>
                                    </div>
                                    <div class="dropdown-menu">
                                        <div class="px-3 py-3">
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'add_comment'" [fG]="workflowCreateForm"
                                                    [cssClass]="''" [labelPosition]="'After'" [cssClass]="'lh-base'"
                                                    [label]="'WORKFLOWADDCOMMENTLABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3">
                                                <app-form-checkbox [fCN]="'visible_for_next_stage'"
                                                    [fG]="workflowCreateForm" [cssClass]="''" [labelPosition]="'After'"
                                                    [cssClass]="'lh-base'"
                                                    [label]="'WORKFLOWVISIBLEFORNEXTSTAGELABEL' | translate"></app-form-checkbox>
                                            </div>
                                            <div class="mb-3 d-flex align-items-center gap-1">
                                                <div class="col-6">
                                                    <app-content [fontSize]="'fs-default'"
                                                        [fontColor]="'text-muted'">Deadline (days)</app-content>
                                                </div>
                                                <div class="col-6">
                                                    <app-form-numeric [fG]="workflowCreateForm"
                                                        [fCN]="'deadline_in_days'"></app-form-numeric>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- Add stage button -->
                <div class="d-flex flex-column align-items-center position-relative">
                    <div style="width: 2px; height: 30px;" class="bg-aqua"></div>
                    <app-form-button [style]="'btn'" [text]="'WORKFLOWADDSTAGEBUTTON' | translate"
                        (click)="onOpenDialog($event,'show-workflowtype')" [icon]="'add_circle'" [iconPosition]="'left'"
                        [cssClass]="'rounded-pill bg-aqua text-white p-2'"
                        [iconClass]="'fs-4 text-white'"></app-form-button>
                    <!-- Only add the bottom line if there is another stage fallowing-->
                    <div *ngIf="true" style="width: 2px; height: 30px;" class="bg-aqua"></div>
                </div>
                <!-- COMPLETED STAGE-->
                <div class="card workflowCard" [class.reviewer_stage]="false">
                    <div class="card-body">
                        <!-- Question Numbering and Options -->
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center pe-1">
                                <app-headline [title]="'END'" [type]="'h6'"
                                    [class]="'fw-bold text-primary'"></app-headline>
                            </div>
                            <div class="d-flex align-items-center gap-1">
                                <app-tooltip [tooltipTarget]="'.stage-options'"
                                    [text]="('WORKFLOWSTAGESETTINGSTOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button [cssClass]="'stage-options e-btn e-flat fs-normal text-muted p-1'"
                                        [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                                        [attr.aria-label]="('WORKFLOWSTAGEOPTIONS' | translate)"></app-form-button>
                                </app-tooltip>
                                <!-- Workflow Type Badge-->
                                <app-pill [fontSize]="'fs-default'" [fontColor]="'text-success'"
                                    [bgColor]="'bg-transparent'" [border]="true" [brdColor]="'brd-success'"
                                    [rounded]="false">Complete</app-pill>
                            </div>
                        </div>
                        <div class="d-flex">
                            <!-- Arrows Up and Down -->
                            <div
                                class="flex-column align-items-center pe-2 gap-3 justify-content-center d-none d-md-flex">
                            </div>
                            <!-- Forms Container -->
                            <div class="d-flex flex-column flex-grow-1 justify-content-start">
                                <div class="d-flex align-items-center flex-wrap gap-2 pt-2">
                                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                                        [title]="'Stage title goes here'"></app-headline>
                                </div>
                                <div class="d-flex align-items-center mt-1 gap-2">
                                    <!-- If notify requester was set -->
                                    <app-pill [bgColor]="'bg-danger'">{{'WORKFLOWCOMPLETENOTIFYREQUESTER' |
                                        translate}}</app-pill>
                                    <!-- If silent was set -->
                                    <app-pill [bgColor]="'bg-success'">{{'WORKFLOWCOMPLETESILENTLY' |
                                        translate}}</app-pill>
                                    <!-- If send email was set -->
                                    <app-pill [bgColor]="'bg-transparent'" [brdColor]="'brd-muted'"
                                        [fontColor]="'text-muted'" [border]="true">stephnxathumanstars.app</app-pill>
                                </div>
                                <div class="my-3">
                                    <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                        [class]="'d-block'">Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor. Evaluate management efficiency by completing this survey,
                                        lorem ipsum dolor.</app-content>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-card">
                        <div class="d-flex justify-content-between align-items-center gap-2">
                            <div class="d-flex align-items-center gap-1">
                                <app-tooltip [tooltipTarget]="'.deletequestion-icon'" [text]="'Delete this Stage'"
                                    [type]="'Default'" [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="true" [cssClass]="'deletequestion-icon e-btn e-flat p-0'"
                                        [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                                </app-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dialogs">
        <!-- Dialog Stage Type -->
        <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #showWorkflowType
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
            [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999"
            [showCloseIcon]="true" (close)="close()">
            <ng-template #header>
                <div class="d-flex align-items-center justify-content-center">
                    <app-headline [title]="('WORKFLOWSTAGETYPESELECTIONDIALOGTITLE' | translate)" [type]="'h5'"
                        [class]="'text-primary'"></app-headline>
                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                        [text]="('WORKFLOWSELECTIONTYPEHELP' | translate)" [width]="'300px'" [height]="'100px'"
                        [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
                </div>
            </ng-template>
            <ng-template #content>
                <div class="d-flex flex-column p-3 custom-scrollbar h-100 overflow-y-auto">
                    <div class="d-flex align-items-center justify-content-center mb-3">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{hoverText}}</app-content>
                    </div>
                    <div class="workflowTypeTiles d-flex flex-wrap align-items-center justify-content-center gap-3">
                        <!--TASK STAGE-->
                        <div [class.selected]="selectedStageType === 'task'"
                            class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3"
                            (mouseenter)="setStageDescription('task')" (click)="selectStage('task')"
                            (mouseleave)="resetToSelectedDescription()">
                            <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                                <div class="d-flex align-items-center justify-content-center gap-3">
                                    <span class="mts-icon notranslate fs-vl lh-1 text-secondary"
                                        translate="no">task_alt</span>
                                </div>
                            </div>
                            <div class="tile-title text-muted text-center mt-3 fs-normal truncate-text-one-line">Task
                                Stage</div>
                        </div>
                        <!-- REVIEWER STAGE-->
                        <div [class.selected]="selectedStageType === 'review'"
                            class="tile d-flex flex-column align-items-center justify-content-between border brd-orange text-center cursor-pointer p-3"
                            (mouseenter)="setStageDescription('review')" (click)="selectStage('review')"
                            (mouseleave)="resetToSelectedDescription()">
                            <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                                <div class="d-flex align-items-center justify-content-center gap-3">
                                    <span class="mts-icon notranslate fs-vl lh-1 text-orange"
                                        translate="no">arrow_split</span>
                                </div>
                            </div>
                            <div class="tile-title text-orange text-center mt-3 fs-normal truncate-text-one-line">Review
                                Stage</div>
                        </div>
                        <!--COMPLETE STAGE-->
                        <div [class.selected]="selectedStageType === 'complete'"
                            class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3"
                            (mouseenter)="setStageDescription('completed')" (click)="selectStage('complete')"
                            (mouseleave)="resetToSelectedDescription()">
                            <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                                <div class="d-flex align-items-center justify-content-center gap-3">
                                    <span class="mts-icon notranslate fs-vl lh-1 text-secondary"
                                        translate="no">assignment_turned_in</span>
                                </div>
                            </div>
                            <div class="tile-title text-muted text-center mt-3 fs-normal truncate-text-one-line">
                                Complete Stage</div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #footerTemplate>
                <div class="d-flex align-items-center justify-content-center p-2">
                    <app-form-button [text]="'WORKFLOWCONTINUEBUTTON' | translate"
                        (click)="onOpenDialog($event, 'show-workflowstagesettings')"
                        [cssClass]="'e-btn e-primary mx-auto'"></app-form-button>
                </div>
            </ng-template>
        </ejs-dialog>

        <!-- Dialog Stage Settings -->
        <ejs-dialog target=".dialogs" class="steps-dialog" [visible]='false' #showWorkflowStageSettings
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
            [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999"
            [showCloseIcon]="false">
            <ng-template #header class="p-1">
                <app-step-header [steps]="steps" [(activeStep)]="activeStep"></app-step-header>
            </ng-template>
            <ng-template #content>
                <div class="d-flex h-100">
                    <!-- Left Column -->
                    <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
                        <div class="text-center mb-4 pt-m">
                            <app-headline [title]="'WORKFLOWCREATESTAGETITLE' | translate" [type]="'h5'"></app-headline>
                        </div>
                        <app-step-content [steps]="steps" [(activeStep)]="activeStep"></app-step-content>
                        <div class="save-button-container text-center mt-3 d-none d-md-block">
                            <app-form-button [text]="'WORKFLOWADDSTAGEBACK' | translate" (click)="true"
                                [cssClass]="'e-primary w-100'"></app-form-button>
                        </div>
                    </div>

                    <!-- Right Column -->
                    <div
                        class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="d-flex align-items-center">
                                <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
                                <app-headline *ngIf="activeStep === 2 || activeStep === 3"
                                    [title]="'('+('OPTIONALLABEL' | translate) +')'" [type]="'h6'"
                                    [class]="'text-success ms-1'"></app-headline>
                                <div class="ms-2">
                                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                                        [text]="('WORKFLOWCREATENEWSTAGEHELP' | translate)" [width]="'300px'"
                                        [height]="'100px'" [cssClass]="'helpTooltip p-2'"
                                        [opensOn]="'Click'"></app-tooltip>
                                </div>
                            </div>
                            <app-form-button [style]="'btn'" (click)="closeDialog('show-workflowstagesettings')"
                                [cssClass]="'btn-close'"></app-form-button>
                        </div>

                        <div class="custom-scrollbar overflow-y-auto">
                            <form class="p-1 d-flex flex-column h-100">
                                <ng-container [ngSwitch]="activeStep">

                                    <ng-container *ngSwitchCase="0">
                                        <app-form-label [label]="'WORKFLOWSTAGETITLELABEL' | translate" [maxChars]="60"
                                            [currentChars]="workflowCreateForm.controls['workflow_stage_title'].value.length"></app-form-label>
                                        <app-form-input [placeholder]="('WORKFLOWSTAGETITLEPLACEHOLDER' | translate)"
                                            [label]="('WORKFLOWSTAGETITLEPLACEHOLDER' | translate)"
                                            [errorText]="('WORKFLOWSTAGETITLEREQUIRED' | translate)"
                                            [fCN]="'workflow_stage_title'" [fG]="workflowCreateForm"
                                            [maxChars]="60"></app-form-input>
                                        <app-form-label [label]="'WORKFLOWSTAGEDESCRIPTIONLABEL' | translate"
                                            [maxChars]="300"
                                            [currentChars]="workflowCreateForm.controls['workflow_stage_description'].value.length"></app-form-label>
                                        <app-form-textarea
                                            [placeholder]="('WORKFLOWSTAGEDESCRIPTIONPLACEHOLDER' | translate)"
                                            [fCN]="'workflow_stage_description'" [fG]="workflowCreateForm"
                                            [richText]="false" [maxChars]="300"></app-form-textarea>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="1">
                                        IF COMPLETE STAGE, THEN THIS STEP IS NOT AVAILABLE.
                                        IF IT IS A REQUESTER STAGE, ALLOW EMAIL AND ALL USER/GROUP SELECTION.
                                        IF IT IS A REVIEW STAGE, THEN ONLY ONE USER CAN BE ASIGNED.
                                        <app-form-label
                                            [label]="'WORKFLOWALLUSERSASREQUESTERLABEL' | translate"></app-form-label>
                                        <div class="d-flex flex-column mb-3">
                                            <app-form-radio [fG]="workflowCreateForm" [fCN]="'workflow_for_all_users'"
                                                [value]="'single'"
                                                [placeholder]="'WORKFLOWALLUSERSCANSTARTLABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                            <!-- Translation: Requester can be any user -->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWALLUSERSCANSTARTDESCRIPTION' |
                                                translate}}</app-content>
                                        </div>
                                        <app-form-label
                                            [label]="'WORKFLOWSELECTEDUSERSASREQUESTERLABEL' | translate"></app-form-label>
                                        <div class="d-flex flex-column mb-3">
                                            <app-form-radio [fG]="workflowCreateForm" [fCN]="'workflow_specific_users'"
                                                [value]="'single'"
                                                [placeholder]="'WORKFLOWSPECIFICUSERSCANSTARTLABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                            <!-- Translation: Only specific users or groups can be requesters -->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWSPECIFICUSERSCANSTARTDESCRIPTION' |
                                                translate}}</app-content>
                                        </div>
                                        IF IT IS A TASK STAGE THEN ALL THE THINGS FROM BELLOW!!
                                        <app-form-label
                                            [label]="'WORKFLOWPARTICIPANTSTYPELABEL' | translate"></app-form-label>
                                        <div class="d-flex flex-column mb-3">
                                            <app-form-radio [fG]="workflowCreateForm"
                                                [fCN]="'workflow_participants_type'" [value]="'single'"
                                                [placeholder]="'WORKFLOWSINGLEASSIGNEELABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                            <!-- Translation: One user is responsible for completing the stage. -->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWSSETTINGSONEUSERSTAGEDESCRIPTION' |
                                                translate}}</app-content>
                                        </div>
                                        <div class="d-flex flex-column mb-3">
                                            <app-form-radio [fG]="workflowCreateForm"
                                                [fCN]="'workflow_participants_type'" [value]="'team'"
                                                [placeholder]="'WORKFLOWTEAMUSERSLABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                            <!--Translation: Assigned users work together on a shared form. One must finalize the stage.-->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWSSETTINGSTEAMSTAGEDESCRIPTION' |
                                                translate}}</app-content>
                                        </div>
                                        <app-form-user-group-mail [allowEmails]="true" [allowPush]="true" [can]="''"
                                            [(user)]="participantsUserIDs" [(groups)]="participantsGroupIDs"
                                            (mailsChange)="participantsMails = $event"
                                            (pushUserIDsChange)="pushUserIDs = $event"
                                            (pushGroupIDsChange)="pushGroupIDs = $event"></app-form-user-group-mail>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="2">
                                        <!--REMOVED FOR SECURITY REASONS AGREED WITH CJ 19.05.25
                            <div class="d-flex flex-column mb-3">
                                <app-form-checkbox [fCN]="'workflow_generate_link_requesters'" [fG]="workflowCreateForm" [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'" [label]="'WORKFLOWGENERATELINKFORREQUESTERSLABEL'"></app-form-checkbox>
                                 Translation: Link will be available in the workflows info panel once the workflow was saved
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [class]="'d-block'">{{'WORKFLOWGENERATELINKFORREQUESTERSDESCRIPTION' | translate}}</app-content>
                            </div>-->

                                        IF IT IS A COMPELTE STAGE
                                        <div class="d-flex flex-column mb-2">
                                            <app-form-label
                                                [label]="'WORKFLOWSENDEMAILTOADDRESSLABEL' | translate"></app-form-label>
                                            <!-- Translation: The outcome of the workflow will be sent to the specified e-mail address. -->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWSENDEMAILWITHOUTCOMEDESCRIPTION' |
                                                translate}}</app-content>
                                            <div class="col-12 col-md-6">
                                                <app-form-input
                                                    [placeholder]="('WORKFLOWTYPEEMAILADDRESSPLACEHOLDER' | translate)"
                                                    [label]="('WORKFLOWTYPEEMAILADDRESSPLACEHOLDER' | translate)"
                                                    [fCN]="'workflow_stage_title'" [fG]="workflowCreateForm"
                                                    [errorText]="('WORKFLOWEMAILWRONGFORMAT' | translate)"></app-form-input>

                                            </div>
                                        </div>
                                        <div class="d-flex flex-column mb-3">
                                            <!--Translation: Notify the requester that the workflow has ended.-->
                                            <app-form-radio [fG]="workflowCreateForm" [fCN]="'return_to_requester'"
                                                [value]="'single'"
                                                [placeholder]="'WORKFLOWNOTIFYREQUESTERONCOMPLETEDLABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                            <!-- Translation: The requester can view the outcome of the workflow. -->
                                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                                [class]="'d-block'">{{'WORKFLOWNOTIFYREQUESTERONCOMPLETEDDESCRIPTION' |
                                                translate}}</app-content>
                                        </div>
                                        <div class="d-flex flex-column mb-3">
                                            <!--Translation: End workflow without notifying the requester.-->
                                            <app-form-radio [fG]="workflowCreateForm" [fCN]="'end_workflow_silentely'"
                                                [value]="'multiple'"
                                                [placeholder]="'WORKFLOWENDSSILENTELYLABEL' | translate"
                                                [cssClass]="'e-normal'"></app-form-radio>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </form>
                        </div>

                        <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
                            <app-form-button [text]="'PREV' | translate" *ngIf="activeStep > 0"
                                (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-20'"></app-form-button>
                            <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep < steps.length - 1"
                                (click)="activeStep = activeStep + 1"
                                [cssClass]="'e-secondary ms-auto w-20'"></app-form-button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #footerTemplate>
                <div class="d-md-none d-flex gap-2 p-2">
                    <div class="flex-shrink-0">
                        <app-form-button [text]="'PREV' | translate" *ngIf="activeStep > 0"
                            (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-100 mx-1'"></app-form-button>

                        <!-- Dummy button to keep the space for the flex container -->
                        <app-form-button *ngIf="activeStep === 0" [text]="'PREV' | translate"
                            [cssClass]="'e-outline invisible w-100 mx-1'"></app-form-button>
                    </div>
                    <div class="flex-grow-1 d-flex justify-content-center">
                        <app-form-button [text]="'CREATEFEEDBACK' | translate" [disabled]="workflowCreateForm.invalid"
                            (click)="onOpenDialog($event,'start-feedbackcomposer')"
                            [cssClass]="'e-primary w-90'"></app-form-button>
                    </div>
                    <div class="flex-shrink-0">
                        <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep < steps.length - 1"
                            (click)="activeStep = activeStep + 1"
                            [cssClass]="'e-secondary w-100 mx-1'"></app-form-button>

                        <!-- Dummy button to keep the space for the flex container -->
                        <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep === steps.length - 1"
                            [cssClass]="'e-secondary invisible w-100 mx-1'"></app-form-button>
                    </div>
                </div>
            </ng-template>
        </ejs-dialog>

        <!-- Dialog for Stage Participants -->
        <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #showAllStageParticipants
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' #showEventParticipantsDialog
            [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40%'"
            [height]="'60vh'" [zIndex]="999" [showCloseIcon]="true">
            <ng-template #header>
                <div class="d-flex align-items-center justify-content-center">
                    <app-headline [title]="('WORKFLOWSTAGEPARTICIPANTSTITLE' | translate)" [type]="'h5'"
                        [class]="'text-primary'"></app-headline>
                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                        [text]="('WORKFLOWSTAGEPARTICIPANTSHELP' | translate)" [width]="'300px'" [height]="'100px'"
                        [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
                </div>
            </ng-template>
            <ng-template #content>
                <div class="d-flex flex-column h-100 p-3">
                    <app-form-input [placeholder]="('SEARCHFORUSER' | translate)" [iconFront]="'search'"
                        [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_user_string'"
                        [fG]="workflowCreateForm"></app-form-input>
                    <h6 class="text-center text-secondary">Participant could not be found!</h6>
                    <!-- SCrollable content-->
                    <div class="custom-scrollbar overflow-y-auto">
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                        <div class="card participants-item mb-2">
                            <div class="d-flex align-items-stretch">
                                <div class="d-flex align-items-center p-1 me-1">
                                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'"
                                        [name]="'Stefan Dragosici'" [type]="'small'" [icon]="'person'"
                                        [border]="false"></app-avatar>
                                </div>

                                <div class="flex-grow-1 lh-1 d-flex align-items-center">
                                    <app-tooltip [text]="'Stefan Dragosici'" [opensOn]="'Auto'">
                                        <app-headline [type]="'h6'" [title]="'Stefan Dragosici'"
                                            [class]="'text-muted fs-small'"></app-headline>
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-light'">{{ 'USER' |
                                            translate }}</app-content>
                                    </app-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-dialog>
    </div>
</div>